// import { AppContext } from '@src/reducer';
import ChangePassword from '@components/ChangePassword/Index';
import ContactAdmin from '@components/ContactAdmin/Index';
import Dashboard from '@components/Dashboard/Index';
import ForgotPassword from '@components/ForgotPassword/Index';
import GetStarted from '@components/GetStarted/Index';
import { AppProvider } from '@components/Hooks/useGlobalState';
import Impersonate from '@components/Impersonate/Index';
import Reset from '@components/Impersonate/Reset';
import Login from '@components/Login/Index';
import Logout from '@components/Logout/Index';
import Search from '@components/Search/Index';
import SetPassword from '@components/SetPassword/Index';
import React from 'react';
import ReactDom from 'react-dom';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import './styles/application.scss'; // Import CSS

// USE THIS ONCE WE OWN "portal.www.suncom.fl.gov"
if (!window.location.host.startsWith('localhost') && !window.location.host.startsWith('portal')) {
  if (!window.location.host.startsWith('www')
    && !window.location.host.startsWith('qa')
    && !window.location.host.startsWith('dev')
    && !window.location.host.startsWith('dr')
    && window.location.host.includes('.fl.gov')
  ) {
    location.replace(window.location.href.replace('https://', 'https://portal.www.'));
  }
  else {
    location.replace(window.location.href.replace('https://', 'https://portal.'));
  }
}

const router = () => {
  return (
    <Router>
      <AppProvider>
        <Switch>

          <Route path='/login' component={Login} />
          <Route path='/logout' component={Logout} />
          <Route path='/contact-admin' component={ContactAdmin} />
          <Route path='/get-started' component={GetStarted} />
          <Route path='/change-password' component={ChangePassword} />
          <Route path='/forgot-password' component={ForgotPassword} />
          <Route path='/set-password/:email/:token' component={SetPassword} />
          <Route path='/impersonate/reset' component={Reset} />
          <Route path='/impersonate' component={Impersonate} />
          <Route path='/search-more/type/:type/terms/:terms' component={Search} />
          <Route path='/search-more' component={Search} />
          <Route path='/widget/:widget' component={Dashboard} />
          <Route path='/' component={Dashboard} />
        </Switch>
      </AppProvider>
    </Router>
  );
};

ReactDom.render(router(), document.getElementById('js-application'));